import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LocaleService } from '@next/core-lib/i18n';
import { map } from 'rxjs';

export function toLocaleSignal(localeService: LocaleService): Signal<string> {
  return toSignal(
    localeService.localeDataChanged$.pipe(map(() => localeService.getLocale())),
    { initialValue: localeService.getLocale() },
  );
}
